/* eslint-disable no-secrets/no-secrets */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PaymentDetailsPage } from 'twia-capability-policychange-common-react';
import TWIAEffectiveDatePage from './pages/EffectiveDate/EffectiveDate.jsx';
import QuoteAndReviewPage from './pages/QuoteReview/QuoteAndReviewPage.jsx';
// import { PolicyDetailsPage, PaymentDetailsPage } from 'twia-capability-change-common-react'; - change it when working on these pages
import CoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage.jsx';
import AdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage.jsx';
import BuildingsAndLocationsPage from './pages/BuildingsAndLocations/BuildingsAndLocationsPage.jsx';
// Dummy Pages
import TWIAChangePolicyDetailsPage from './pages/PolicyChangeDetails/PolicyChangeDetails.jsx';

setComponentMapOverrides(
    {
        TWIAChangeCPEffectiveDatePage: { component: 'TWIAChangeCPEffectiveDatePage' },
        TWIAChangeCPPolicyDetailsPage: { component: 'TWIAChangeCPPolicyDetailsPage' },
        TWIAChangeCPBuildingsAndLocationsPage: { component: 'TWIAChangeCPBuildingsAndLocationsPage' },
        TWIAChangeCPQuotePage: { component: 'TWIAChangeCPQuotePage' },
        TWIAChangeCPAdditionalInformationPage: { component: 'TWIAChangeCPAdditionalInformationPage' },
        TWIAChangeCPCoverageSummaryPage: { component: 'TWIAChangeCPCoverageSummaryPage' },
        TWIAChangeCPPaymentDetailsPage: { component: 'TWIAChangeCPPaymentDetailsPage' }

    },
    {
        TWIAChangeCPEffectiveDatePage: TWIAEffectiveDatePage,
        TWIAChangeCPPolicyDetailsPage: TWIAChangePolicyDetailsPage,
        TWIAChangeCPBuildingsAndLocationsPage: BuildingsAndLocationsPage,
        TWIAChangeCPQuotePage: QuoteAndReviewPage,
        TWIAChangeCPAdditionalInformationPage: AdditionalInformationPage,
        TWIAChangeCPCoverageSummaryPage: CoverageSummaryPage,
        TWIAChangeCPPaymentDetailsPage: PaymentDetailsPage
    }
)

export { default as TWIACommercialChangeWizard } from './TWIACommercialChangeWizard.jsx';
